// extracted by mini-css-extract-plugin
export default {"icon":"services_icon__WtYkE","services":"services_services__Y8izE","container":"services_container__K6tMe","heading":"services_heading__SpLAM"};